import { Button, Menu } from "@mui/material";
import { useState } from "react";
import { List } from "react-feather";

export const CustomDropDown = (props) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button 
                startIcon = { <List/>}
                variant='contained'
                size='small' 
                color={props?.color || 'inherit'}
                sx={{ marginRight: '8px' }}
                onClick={handleMenuOpen} 
                style={ { width: 150 } }
                > 
                Opciones
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
            >
                {props.children}
            </Menu>
        </>
    );
}
